

import axios from "axios";

// get products by category
export const getsimilarproduct = async (productId) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/similar-products/?product_id=${productId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching products:", error);
    throw error;
  }
};